import { render } from "./APIRibbon.vue?vue&type=template&id=6609b8e5"
import script from "./APIRibbon.vue?vue&type=script&lang=js"
export * from "./APIRibbon.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/360pt/V3/v2026.11.r3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__